import { Table, ActionIcon, Image, Text, Flex } from '@mantine/core';
import {
  IconTrash,
} from '@tabler/icons-react';

import { CustomTable, CustomTableMobile, useResponsive } from '@/shared';
import { convertImagesToTable } from '../../utils/helpers/converter';

import type { TConfigImage, TConfigDeleteImageParams } from '../../store/types';

type Props = {
  items: TConfigImage[];
  itemsCount?: number;
  pageSize?: number;
  currentPage?: number;
  isLoading?: boolean;
  onPageChange?: (page: number) => void;
  handleDeleteImage: (values: TConfigDeleteImageParams) => void;
};

export const ImagesTable = (props: Props) => {
  const {
    items,
    handleDeleteImage,
  } = props;

  const { isDesktop } = useResponsive();

  const getImage = (item: TConfigImage) => (
    <Image
      h={20}
      w="auto"
      fit="contain"
      src={`https://bpay.tw/api/image/${item.filename}`}
    />
  );

  const getActions = (item: TConfigImage) => (
    <ActionIcon color="red" onClick={() => handleDeleteImage({ imageId: item.id })}>
      <IconTrash size={16} />
    </ActionIcon>
  );

  const titles = [
    'ID',
    '',
    'Имя файла',
    'Создан',
  ];

  const rows = convertImagesToTable(items).map((item) => (
    <Table.Tr key={item.id}>
      <Table.Td>{item.id}</Table.Td>
      <Table.Td>{getImage(item)}</Table.Td>
      <Table.Td>{item.filename}</Table.Td>
      <Table.Td>{item.created}</Table.Td>
      <Table.Td width={50}>{getActions(item)}</Table.Td>
    </Table.Tr>
  ));

  const rowsMobile = convertImagesToTable(items).map((item) => ({
    key: item.id,
    headerActions: getActions(item),
    items: [
      { name: titles[1], value: <Flex gap={20}><div>{`ID: ${item.id}`}</div><div>{getImage(item)}</div></Flex> },
      // { name: titles[0], value: item.id },
      { name: titles[2], value: <Text truncate="end" size="xs">{item.filename}</Text> },
      { name: titles[3], value: item.created },
    ],
  }));

  return isDesktop
    ? (
      <CustomTable
        titles={titles}
        rows={rows}
        {...props}
      />
    )
    : (
      <CustomTableMobile
        rows={rowsMobile}
        headerPointsCount={1}
        {...props}
      />
    );
};
